import React from 'react';
import PropTypes from 'prop-types';
import { KPI_GREEN, KPI_RED, KPI_YELLOW } from '../../../core/chart/colors';

export default function PlacementTestReportTestDialogAnsweredItemsBar(props) {
  const total = props.answeredItems.length;
  const correctAnswers = props.answeredItems.filter((answeredItem) => answeredItem.correct).length;
  const wrongAnswers = props.answeredItems.filter(
    (answeredItem) => !answeredItem.correct && answeredItem.answer !== null
  ).length;
  const missedAnswers = props.answeredItems.filter((answeredItem) => answeredItem.answer === null).length;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      <div
        style={{
          width: '100%',
          height: '40px',
          borderRadius: '35px',
          backgroundColor: '#e8e8e8',
          position: 'relative',
          overflow: 'hidden',
          display: 'flex',
        }}
      >
        {total > 0 && (
          <>
            <div
              style={{
                position: 'absolute',
                width: `${(correctAnswers / total) * 100}%`,
                left: 0,
                height: '100%',
                backgroundColor: KPI_GREEN,
              }}
            />
            <div
              style={{
                position: 'absolute',
                width: `${(missedAnswers / total) * 100}%`,
                left: `${(correctAnswers / total) * 100}%`,
                height: '100%',
                backgroundColor: KPI_YELLOW,
              }}
            />
            <div
              style={{
                position: 'absolute',
                width: `${(wrongAnswers / total) * 100}%`,
                left: `${(correctAnswers / total + missedAnswers / total) * 100}%`,
                height: '100%',
                backgroundColor: KPI_RED,
              }}
            />
          </>
        )}
      </div>
      <div style={{ marginTop: '15px', width: '100%', display: 'flex', justifyContent: 'space-between' }}>
        {correctAnswers > 0 && (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ width: '10px', height: '10px', marginRight: '5px', backgroundColor: KPI_GREEN }} />
            <span
              style={{
                fontSize: '14px',
                fontWeight: 'bold',
                textAlign: 'center',
              }}
            >
              {correctAnswers} correct ({((correctAnswers / total) * 100).toFixed(1)}%)
            </span>
          </div>
        )}
        {missedAnswers > 0 && (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ width: '10px', height: '10px', marginRight: '5px', backgroundColor: KPI_YELLOW }} />
            <span
              style={{
                fontSize: '14px',
                fontWeight: 'bold',
                textAlign: 'center',
              }}
            >
              {missedAnswers} not answered ({((missedAnswers / total) * 100).toFixed(1)}%)
            </span>
          </div>
        )}
        {wrongAnswers > 0 && (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ width: '10px', height: '10px', marginRight: '5px', backgroundColor: KPI_RED }} />
            <span
              style={{
                fontSize: '14px',
                fontWeight: 'bold',
                textAlign: 'center',
              }}
            >
              {wrongAnswers} wrong ({((wrongAnswers / total) * 100).toFixed(1)}%)
            </span>
          </div>
        )}
      </div>
    </div>
  );
}

PlacementTestReportTestDialogAnsweredItemsBar.propTypes = {
  answeredItems: PropTypes.array,
};

PlacementTestReportTestDialogAnsweredItemsBar.defaultProps = {
  answeredItems: [],
};
